import React, { Component } from "react";
import PropTypes from "prop-types";
import { Spin, Modal, Tabs } from "antd";
const TabPane = Tabs.TabPane;

const styles = {
  multilineText: {
    height: 300,
    overflowY: "auto",
    whiteSpace: "pre-line"
  }
};

class PublicationsInclusion extends Component {
  static propTypes = {
    pubs: PropTypes.arrayOf(PropTypes.string),
    esUrl: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
  };

  static defaultProps = {
    pubs: []
  };

  state = {
    included: [],
    notIncluded: [],
    loading: false,
    visibleModal: false
  };

  componentDidMount() {
    this._isMounted = true;
    this._getData(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (JSON.stringify(nextProps) !== JSON.stringify(this.props)) {
      this._getData(nextProps);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { loading, included, notIncluded } = this.state;
    const pubs = this.props.pubs;
    return loading ? (
      <Spin size="small" />
    ) : pubs && pubs.length && (included.length || notIncluded.length) ? (
      <div>
        <a onClick={() => this.setState({ visibleModal: true })}>
          <small>{`${pubs.length} Searched | ${included.length} Covered | ${notIncluded.length} Not Found`}</small>
        </a>
        <Modal footer={null} open={this.state.visibleModal} onCancel={() => this.setState({ visibleModal: false })}>
          <Tabs defaultActiveKey="pubs">
            <TabPane tab={`${pubs.length} Searched`} key="pubs">
              <p className="ant-input" style={styles.multilineText}>{`${pubs.join("\n")}`}</p>
            </TabPane>
            <TabPane tab={`${included.length} Covered`} key="included">
              <p className="ant-input" style={styles.multilineText}>{`${included.join("\n")}`}</p>
            </TabPane>
            <TabPane tab={`${notIncluded.length} Not Found`} key="not-included">
              <p className="ant-input" style={styles.multilineText}>{`${notIncluded.join("\n")}`}</p>
            </TabPane>
          </Tabs>
        </Modal>
      </div>
    ) : null;
  }

  _getData = props => {
    const { pubs, esUrl } = props;
    if (pubs && pubs.length) {
      if (this._isMounted)
        this.setState(
          {
            loading: true
          },
          () =>
            this.props
              .onChange(esUrl, pubs)
              .then(res => {
                if (this._isMounted)
                  this.setState({
                    included: res.in,
                    notIncluded: res.not_in,
                    loading: false
                  });
              })
              .catch(() => {
                if (this._isMounted)
                  this.setState({
                    included: [],
                    notIncluded: [],
                    loading: false
                  });
              })
        );
    } else {
      if (this._isMounted)
        this.setState({
          included: [],
          notIncluded: []
        });
    }
  };
}

export default PublicationsInclusion;
